import * as types from './types'
import User from '@/services/api/user'
import Media from '@/services/api/media'

export const actions = {
    login ({ commit }, __user) {
        return new Promise((resolve, reject) => {
            User.login(__user.email, __user.password)
            .then((data) => {
                commit(types.LOGIN, data)
                User.getUser().then((response) => {
                  commit(types.SET_USER, response)
                  resolve()
                }).catch((error) => {
                  reject(error)
                })
            }).catch((e) => {
                // commit(types.LOGOUT)
                reject(e)
            })
        })
    },
    logout ({ commit, state }) {
        return new Promise((resolve, reject) => {
            User.logout().then(() => {
                commit(types.LOGOUT)
                resolve()
            }).catch((error) => {
                reject(error)
            })
        })
    },
    getUser ({ commit, state }) {
      return new Promise((resolve, reject) => {
        User.getUser().then((response) => {
          commit(types.SET_USER, response)
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    updateProfilePicture ({ commit, state }, data) {
        return new Promise((resolve, reject) => {
            // commit('LOADER_IN')
            Media.updateProfilePicture(data, state.user.id).then((response) => {
                // commit('LOADER_OUT')
                commit(types.PROFIL_PICTURE, response.data)
                resolve()
            }).catch((error) => {
                // commit('LOADER_OUT')
                reject(error)
            })
        })
    },
    saveProfile ({ commit }, data) {
        return new Promise((resolve, reject) => {
            // commit('LOADER_IN')
            User.updateProfile(data).then((response) => {
                // commit('LOADER_OUT')
                commit(types.UPDATE_PROFILE, data)
                resolve()
            }).catch((error) => {
                // commit('LOADER_OUT')
                reject(error)
            })
        })
    },
    editPassword ({ commit }, data) {
        return new Promise((resolve, reject) => {
            // commit('LOADER_IN')
            User.editPassword(data).then((response) => {
                // commit('LOADER_OUT')
                if (response.status === 201) {
                    resolve(response)
                } else {
                    reject(new Error())
                }
            }).catch((error) => {
                // commit('LOADER_OUT')
                reject(error)
            })
        })
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/Users/actions.js